import React from "react";

import { ControllerRenderProps } from "react-hook-form";

import { Checkbox } from "src/base-components/Checkbox";
import { InputMappings } from "src/integrationNode/types";

type Props = {
  option: { key: string; value: string };
  controllerFieldProps: ControllerRenderProps<
    InputMappings,
    `multiselectors.${string}.selected`
  >;
  immutable: boolean;
};

export const MultiSelectorCheckbox: React.FC<Props> = ({
  option,
  controllerFieldProps,
  immutable,
}) => {
  const fieldValue = controllerFieldProps.value ?? [];
  const optionIsChecked = !!fieldValue.find((ticked) => ticked === option.key);
  return (
    <div className="flex font-inter-normal-12px text-gray-800">
      <Checkbox
        checked={optionIsChecked}
        className="mr-1.5"
        disabled={immutable}
        id={option.value}
        onChange={() => {
          if (optionIsChecked) {
            controllerFieldProps.onChange(
              fieldValue.filter((ticked) => ticked !== option.key),
            );
          } else {
            controllerFieldProps.onChange([...fieldValue, option.key]);
          }
        }}
      />
      <label htmlFor={option.value}>{option.value}</label>
    </div>
  );
};
